// @flow

import { type Country } from '@tectonics/prs/country';

export function getDebitCardBrandsForCountry(country: Country): Array<string> {
  switch (country) {
    case 'br':
      return [
        'nubank',
        'santander',
        'bancodobrasil',
        'caixa',
        'bradesco',
        'original',
        'inter',
        'c6',
        'bancoob',
        'bancopan',
        'sicredi',
        'agibank',
        'bancobmg',
        'brb',
        'itau',
      ];

    case 'uy':
      return ['visa'];

    case 'py':
      return ['visa', 'mastercard', 'infonet'];

    case 'ar':
      return ['visa', 'mastercard'];

    case 'cl':
      return ['visa', 'mastercard'];

    case 'pa':
      return ['visa', 'mastercard'];

    case 'sv':
      return ['visa', 'mastercard'];

    case 'gt':
      return ['visa', 'mastercard'];

    case 'do':
      return ['visa', 'mastercard'];

    case 'cr':
      return ['visa', 'mastercard'];

    case 'ke':
      return ['visa', 'mastercard'];

    case 'ng':
      return ['visa', 'mastercard', 'verve'];

    case 'za':
      return ['visa', 'mastercard'];

    case 'eg':
      return ['visa', 'mastercard', 'meeza'];

    case 'co':
      return ['visa', 'mastercard', 'diners'];
    case 'ec':
      return ['visa', 'mastercard', 'diners'];

    case 'in':
      return ['visa', 'mastercard', 'rupay'];

    case 'jm':
      return ['visa', 'mastercard'];

    default:
      throw new Error(`getDebitCardBrandsForCountry - there is no debit card brands implementation for country "${country}".`);
  }
}
